import React from 'react';
import { EditorState } from 'draft-js';

import OptionRow from './OptionRow';
import { AddOptionButton, Wrapper } from './styles';
import { MultiSelectOptionItem, MultiSelectOptionsEditorProps } from './types';
import { useMultiSelectOptions } from './useMultiSelectOptions';

const MultiSelectOptionsEditor: React.FC<MultiSelectOptionsEditorProps> = (
  props,
) => {
  const {
    options,
    editors,
    collapsed,
    toggleRow,
    changeLabel,
    changeValue,
    changeImage,
    changeIcon,
    changeExclusive,
    addOption,
    removeOption,
    moveOption,
  } = useMultiSelectOptions(props);
  const showImages = Boolean(props.showImages);
  const showExclusive = Boolean(props.showExclusive);

  return (
    <Wrapper>
      <div className="mso-heading">
        <span className="mso-heading-title">Options</span>
        <span className="mso-heading-hint">
          Format each label, then pick its stored value
        </span>
      </div>

      {options.map((option: MultiSelectOptionItem, index: number) => (
        <OptionRow
          key={option.key}
          option={option}
          index={index}
          isOpen={!collapsed[option.key]}
          editorState={editors[option.key] || EditorState.createEmpty()}
          canRemove={options.length > 1}
          canMoveUp={index > 0}
          canMoveDown={index < options.length - 1}
          showImage={showImages}
          showExclusive={showExclusive}
          onToggle={toggleRow}
          onLabelChange={changeLabel}
          onValueChange={changeValue}
          onImageChange={changeImage}
          onIconChange={changeIcon}
          onExclusiveChange={changeExclusive}
          onRemove={removeOption}
          onMove={moveOption}
        />
      ))}

      <AddOptionButton type="button" onClick={addOption}>
        Add option
      </AddOptionButton>
    </Wrapper>
  );
};

export default MultiSelectOptionsEditor;
